import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2.5),
    },
  },
  label: {
    textAlign: 'center',
    fontWeight: 'bold',
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'inherit',
    },
  },
}));

const LargeButton = ({ children, ...other }) => {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.root}
      classes={{ root: classes.root, label: classes.label }}
      {...other}
    >
      {children}
    </Button>
  );
};

export default LargeButton;
